import { Action, LoadingReducer, initialState } from "./reducer"
import React, { Dispatch, ReactNode, useReducer } from "react"

const LoadingStateContext = React.createContext<typeof initialState | undefined>(undefined)
const LoadingDispatchContext = React.createContext<Dispatch<Action> | undefined>(undefined)

const useLoadingState = () => {
    const context = React.useContext(LoadingStateContext)
    if (context === undefined) {
        throw new Error("useLoadingState must be used within a LoadingProvider")
    }

    return context
}

const useLoadingDispatch = () => {
    const context = React.useContext(LoadingDispatchContext)
    if (context === undefined) {
        throw new Error("useLoadingDispatch must be used within a LoadingProvider")
    }

    return context
}

type LoadingProviderProps = {
    children: ReactNode
}

const LoadingProvider = ({ children }: LoadingProviderProps) => {
    const [state, dispatch] = useReducer(LoadingReducer, initialState)

    return (
        <LoadingStateContext.Provider value={state}>
            <LoadingDispatchContext.Provider value={dispatch}>{children}</LoadingDispatchContext.Provider>
        </LoadingStateContext.Provider>
    )
}

export { useLoadingState, useLoadingDispatch, LoadingProvider }
